import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import makeApiCall from '../../../api/makeApiCall';

import {leadList, leadReject} from '../../../api/request/leadApi/leadApi';
import Strings from '../../../constants/stringConstant';
// import {toast} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';
import {setPayLoadValue} from '../../../state/slice/leadListPayloadSlice';
import {leadValue} from '../../../state/slice/leadSlice';
import Path from '../../../constants/path';
import ModalwithButton from '../../../components/Modal/modalwithButton';
import LeadReject from './LeadReject/leadReject';
import SuccessModal from '../../../components/Modal/successModal';

import DashboardComponent from '../../../components/Dashboard/dashboard';
import NameCard from '../../../components/NameCard/nameCard';
import {getUserData, hasEditValue} from '../../../utils/appUtils';

const LeadDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {roleBased} = useSelector(state => state.rbacValue);
  const {lead} = useSelector(state => state.lead);
  const {selectedTab, currentPage, searchQuery} = useSelector(
    state => state.leadListPayload,
  );
  const {filters} = useSelector(state => state.filterValue);
  const userData = getUserData();
  const [cards, setCards] = useState([]);
  const [rejectModal, setRejectModal] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rejectedDone, setRejectedDone] = useState(false);
  const [refreshTrue, setRefreshTrue] = useState(false);
  const [totalCount, setTotalCount] = useState('');
  const [rejectValue, setRejectValue] = useState({
    reasonCategory: '',
    reasonSubCategory: '',
    remark: '',
  });
  const tabs = [
    {key: 'Incomplete', value: 'Incomplete'},
    {key: 'Follow_up', value: 'Pending For Follow-up'},
    {key: 'Rejected', value: 'Rejected'},
    {key: 'Completed', value: 'Completed'},
  ];

  const cardsPerPage = 15;

  const paths = [
    {
      name: Strings.leadManagement.lead_management_header,
      link: Path.lead_management,
    },
  ];

  const fetchPaginationData = async (
    state,
    branch,
    createdBy,
    pageNumber = currentPage,
  ) => {
    setLoading(true);
    try {
      const payload = {
        employeeId: userData?.userId,
        status: selectedTab,
        pageNumber: pageNumber - 1,
        pageSize: 15,
        searchTerm: searchQuery,
        createdBy: createdBy || filters.CreatedBy || [],
        state: state || filters.State || [],
        branchId: branch || filters.Branch || [],
      };
      const response = await makeApiCall(leadList(payload));
      if (response.data.status === Strings.success) {
        setLoading(false);
        const responseValue = response.data.data;
        setCards(responseValue?.data);
        setTotalCount(responseValue?.totalCount);
        setTotalPages(Math.ceil(responseValue?.totalCount / cardsPerPage));
      } else {
        setLoading(false);
        if (response.data.status === Strings.error) {
          if (response?.data?.error?.errorCode === 'SAMASTA015') {
            setTotalPages(0);
          }
          setCards([]);
        }
      }
    } catch (error) {
      setLoading(false);
      // toast.error(Strings.apiError, {
      //   position: 'top-right',
      // });
      console.log('failed:', error);
    }
  };

  const handlePageChange = (event, value) => {
    dispatch(setPayLoadValue({currentPage: value}));
    fetchPaginationData(
      filters.State,
      filters.Branch,
      filters.CreatedBy,
      value,
    );
  };

  const handleTabClick = tabName => {
    dispatch(setPayLoadValue({selectedTab: tabName, currentPage: 1}));
  };

  const handleSearch = query => {
    dispatch(setPayLoadValue({searchQuery: query, currentPage: 1}));
  };

  const handleGenerateLead = path => {
    navigate(path, {replace: true});
    dispatch(leadValue({lead: {}, type: Strings.creation_add_type}));
  };
  const handleRejectClose = () => {
    setRejectModal(false);
    setRejectValue({
      reasonCategory: '',
      reasonSubCategory: '',
      remark: '',
    });
  };
  const handleCloseModal = () => {
    setTimeout(() => {
      setRejectedDone(false);
    }, 2000);
    setRefreshTrue(!refreshTrue);
  };
  const handleRejectClick = () => {
    rejectLeadApi();
  };
  const rejectLeadApi = async () => {
    try {
      const payload = {
        rejectCategory: rejectValue.reasonCategory,
        rejectReason: rejectValue.reasonSubCategory,
        rejectedBy: userData?.userId,
        remark: rejectValue.remark,
        leadId: lead.leadId,
      };
      const response = await makeApiCall(leadReject(payload));
      if (response.data.status === Strings.success) {
        handleRejectClose();
        setRejectedDone(true);
        handleCloseModal();
      } else {
        if (response.data.status === Strings.error) {
          console.log(response);
        }
      }
    } catch (error) {
      // toast.error(Strings.apiError, {
      //   position: 'top-right',
      // });
    }
  };

  return (
    <DashboardComponent
      paths={paths}
      buttonOnclick={
        hasEditValue(roleBased?.lead)
          ? () => handleGenerateLead(Path.lead)
          : null
      }
      searchQuery={searchQuery}
      onSearch={handleSearch}
      selectedTab={selectedTab}
      handleTabClick={handleTabClick}
      tabs={tabs}
      cards={cards}
      fetchData={fetchPaginationData}
      CardComponent={NameCard}
      setRejectModal={setRejectModal}
      totalCount={totalCount}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      refreshTrue={refreshTrue}
      buttonName={Strings.leadManagement.create_lead}
      handlePageChange={handlePageChange}
      dashboardType={Strings.leadManagement.lead_type}
      countValue={Strings.leadManagement.count_val}
      modalComponent={
        <>
          <ModalwithButton
            open={rejectModal}
            value={Strings.leadManagement.lead_reject_button}
            onClose={handleRejectClose}
            buttonDisable={
              !(
                rejectValue.reasonCategory &&
                rejectValue.reasonSubCategory &&
                rejectValue.remark
              )
            }
            onClickButton={handleRejectClick}>
            <LeadReject
              dashboardType={Strings.leadManagement.lead_type}
              rejectValue={rejectValue}
              setRejectValue={setRejectValue}
              onClose={handleRejectClose}
            />
          </ModalwithButton>

          <SuccessModal
            open={rejectedDone}
            onClose={handleCloseModal}
            message={Strings.leadManagement.reject_popup_header}
            subMessage={Strings.leadManagement.reject_popup_subheader}
            reject={true}
          />
        </>
      }
    />
  );
};

export default LeadDashboard;
